import PageApp from 'pageApp';
import Cookie from '@component/common/src/util/Cookie';
import ExperimentationSDK from '@component/experiment/src/js/ExperimentationSDK';
import UserStatus from '@component/common/src/util/UserStatus';

export default class Context {
  static generateContextParams() {
    const params = [];
    let context = {};

    if (PageApp.getMeta) {
      context = PageApp.getMeta('context');
      if (context) {
        if (context.shoppingMode) {
          params.push(`_shoppingMode=${context.shoppingMode}`);
        }
        if (context.customerExperiment) {
          params.push(`_customerExperiment=${context.customerExperiment}`);
        }
        if (context.pdpServer) {
          params.push(`pdpserver=${context.pdpServer}`);
        }
      } else {
        params.push(`_customerExperiment=${ExperimentationSDK.getExpIds() || 'NO_EXPERIMENT'}`);
      }
    }

    params.push(`_customerState=${this.getCustomerState()}`);
    params.push(`currencyCode=${Cookie.getCurrencyCode() || 'USD'}`);
    params.push(`_regionCode=${Cookie.getCountryCode() || 'US'}`);

    return params;
  }

  static getCustomerState() {
    const context = (PageApp.getMeta && PageApp.getMeta('context')) || {};

    if (context && context.customerState) {
      return context.customerState;
    } else if ((context && context.signedIn) || UserStatus.isSignedIn()) {
      return 'SIGNED_IN';
    } else if ((context && context.softSignedIn) || UserStatus.isSoftSignedIn()) {
      return 'RECOGNIZED';
    }
    return 'GUEST';
  }
}
